<template>
  <div>
    <PageAllow controller="Economies" action="view" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color py-4 mx-4">
        <!-- 定价单信息 -->
        <v-expansion-panels v-model="panelsDetail" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("EconomiesDetail.title") }}
                <v-chip
                  class="ms-4 mt-1"
                  small
                  label
                  :color="economy.cancel_flg == 1 ? 'danger' : 'primary'"
                  :text-color="economy.status | economiesFlgsTextColor"
                >
                  {{ economy.status | economiesFlgsText }}
                  <span v-if="economy.cancel_flg == 1">
                    {{ "(" }}{{ economy.cancel_flg | cancelFlgsText }}{{ ")" }}
                  </span>
                </v-chip>
                <v-spacer></v-spacer>
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="economy.actions && economy.actions.confirm"
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="Confirm()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-sync-alt</v-icon> -->
                    {{ $t("EconomiesDetail.economies") }}
                  </v-btn>
                  <v-btn
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="Export()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-sync-alt</v-icon> -->
                    {{ $t("EconomiesDetail.export") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-divider></v-divider>
            <v-expansion-panel-content>
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("EconomiesDetail.Fields.economy_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ economy.economy_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("EconomiesDetail.Fields.created")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ economy.created }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("EconomiesDetail.Fields.name",[$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ accountName }}
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panelsDetail.find((p) => p == 1)
                      ? null
                      : panelsDetail.push(1);
                  "
                >
                  {{ $t("EconomiesDetail.activities.title") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        {{ item.created | formatTime }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <!-- 定价单明细 -->
      <div class="px-4 pb-4">
        <v-card class="px-4">
          <v-toolbar flat class="transparent-background-color">
            <v-card-title class="ms-n4 py-0">
              {{ $t("EconomiesDetail.objectName") }}
              <v-spacer />
            </v-card-title>
          </v-toolbar>

          <v-divider />
          <v-data-table
            :headers="headers"
            :items="economy_details"
            :search="search"
            multi-sort
            disable-pagination
            hide-default-footer
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        economy_details
                          ? [
                              economy_details.length > 0 ? 1 : 0,
                              economy_details.length,
                              economy_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="search"
                        clearable
                        :label="$t('Search.filter')"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:item.current_supply_price="{ item }">
              <a @click.stop="
                currentDetail = item;
                lineChartMaterialName = $t(
                  settings
                    ? settings.material_name_display_type == 4
                        ? 'Material.nameWithCodeAndStandard'
                        : settings.material_name_display_type == 3
                      ? 'Material.materialNameWithCodeAndStandard'
                        : settings.material_name_display_type == 2
                        ? 'Material.materialNameWithCode'
                      : 'Material.materialName'
                    : 'Material.materialName',
                  [item.material_code, item.material_name, item.standard_name]
                );
                echartsDialog = true;">
                {{ $t("Global.money") }}{{ item.current_supply_price | formatMoney }}
              </a>

            </template>
            <template v-slot:item.quotation_supply_price="{ item }">
              {{ $t("Global.money") }}{{ item.quotation_supply_price | formatMoney }}
            </template>
            <template v-slot:item.supply_price="{ item }">
              {{ $t("Global.money") }}{{ item.supply_price | formatMoney }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-sheet>
    <DialogEconomyHistoryEcharts
      v-model="echartsDialog"
      :supplierId="accountUser.supplier_id"
      :currentDetail="currentDetail"
      :lineChartMaterialName="lineChartMaterialName"
      @close="echartsDialog = false"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Economy from "@/api/economies";
import DialogEconomyHistoryEcharts from "@/components/plugins/DialogEconomyHistoryEcharts"

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogEconomyHistoryEcharts,
  },

  data: () => ({
    panelsDetail: [0],
    Detail: [0],
    economy: {},
    tab: null,
    search: "",
    activities_details: [],
    economy_details: [],
    echartsDialog: false,
    currentDetail: null,
    lineChartMaterialName: "",
  }),

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountName() {
      if (this.accountInfo) return this.accountInfo.account_name;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.economies"),
        disabled: false,
        href: "/economies",
      },
      {
        text: i18n.t("Nav.economiesIndex"),
        disabled: false,
        href: "/economies",
      },
      {
        text: i18n.t("Nav.economiesDetails"),
        disabled: true,
        href: "/economies",
      },
    ],
    activitiesHeaders: () => [
      {
        text: i18n.t("EconomiesDetail.activities.time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("EconomiesDetail.activities.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("EconomiesDetail.activities.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    headers: () => [
      {
        text: i18n.t("EconomiesDetail.Fields.material_category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.standard"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.old_supply_price"),
        align: "end",
        sortable: false,
        value: "current_supply_price",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.quotation_supply_price"),
        align: "end",
        sortable: false,
        value: "quotation_supply_price",
      },
      {
        text: i18n.t("EconomiesDetail.Fields.supply_price"),
        align: "end",
        sortable: false,
        value: "supply_price",
      },
    ],
    ...mapState(["accountInfo", "accountUser", "settings"]),
  },

  mounted() {
    this.getEconomyFromAPI();
  },

  methods: {
    getEconomyFromAPI() {
      Economy.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.economy = response.data.economy;
            this.activities_details = response.data.order_activities;
            this.economy_details = response.data.economy.economy_details;
          }
        }.bind(this)
      );
    },
    Confirm() {
      this.$store.dispatch("fullscreenLoading");
      Economy.confirm(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getEconomyFromAPI();
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    Export() {
      Economy.exportOne(Object.assign(this.$route.params.id));
    },
  },
};
</script>

<style>
</style>